import { defineComponent as _defineComponent } from 'vue'
import { useSlots, computed } from 'vue'
import { navigateTo } from '@@/bits/location'


export default /*#__PURE__*/_defineComponent({
  __name: 'base_button',
  props: {
    disabled: { type: Boolean, default: false },
    variation: { default: undefined },
    colorScheme: { default: 'default' },
    href: { default: undefined },
    hrefTarget: { default: '_self' },
    xTextMargin: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'click', event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, variation: string, colorScheme: 'default' | 'black' | 'white' | 'green' | 'orange' | 'grey', href: string, hrefTarget: string, xTextMargin: boolean }



const slots = useSlots()



const hasText = computed(() => !!slots.default && slots.default().toString().trim() !== '')

const hasIcon = computed(() => !!slots.icon)

const variationClass = computed(() => {
  switch (props.variation) {
    case 'contained':
    case 'flat':
      return 'flat-button'
    case 'text':
      return 'text-button'
    case 'fat-contained':
      return 'fat-contained-button'
    case 'small-contained':
      return 'small-contained-button'
    case 'large-contained':
      return 'large-contained-button'
    case 'fat-text':
      return 'fat-text-button'
    case 'fat-text-lower':
      return 'fat-text-button lower'
    case 'bordered-text':
      return 'fat-text-button bordered-text-button'
    case 'flat-bordered':
      return 'flat-button bordered-flat-button'
    default:
      return 'text-button'
  }
})

const iconClass = computed(() => {
  const iconClassesArray: string[] = []
  if (hasIcon.value) {
    iconClassesArray.push('icon-button')
  }
  if (!hasText.value) {
    iconClassesArray.push('button-without-text')
  }
  if (props.variation === 'bordered-icon') {
    iconClassesArray.push('bordered-icon-button')
  }
  return iconClassesArray.join(' ')
})

const colorSchemeClass = computed(() => props.colorScheme + '-color')

const classNames = computed(() => [
  'button',
  !(hasIcon.value && !hasText.value) ? variationClass.value : '',
  colorSchemeClass.value,
  iconClass.value,
  props.xTextMargin ? '' : 'no-text-margin',
])

function click(event): void {
  if (props.href) {
    navigateTo(props.href, { target: props.hrefTarget })
  }
  emit('click', event)
}

return { __sfc: true,props, slots, emit, hasText, hasIcon, variationClass, iconClass, colorSchemeClass, classNames, click }
}

})